import React from 'react'
import { PageTitle, Paragraph, ParaTitle, Pagination} from "../common";
import './Updates.css';

const Updates_3_44_0 = () => {
  return (
    <div>
      <PageTitle title='3.44.0' />

      <ParaTitle paraTitle='System Upgrade & UI Improvement' />
      <Paragraph paragraph='2025-07-14' />

      {/* <ParaTitle paraTitle='Added:' />
      <ul>
        <li>
          Facility sundown page
          <p>The facility sundown page now indicates how simple or complex it is to deactivate a facility. 
            This change helps streamline the sundown process by providing a clear guide and procedure, 
            making it easier for developers and facilities that are leaving the system.</p>
        </li>
      </ul> */}

      <ParaTitle paraTitle='Changed:' />
      <ul>
        <li>Upgraded system to PHP 8.4 and Yii 2.0.53
          <p>
            Upgraded the system environment to PHP 8.4 and Yii 2.0.53
            to enhance security, performance, and compatibility.
          </p>
        </li>
        <li>Update UI to Make Drafts Easier to Find
          <p>
          UI dashboards have been updated to make drafts easier to locate in the tables, 
          with incomplete drafts clearly highlighted for quick access and completion. 
          This change addresses the feedback from the Open House.
          </p>
        </li>
        <li>Improve Settings UI
          <p>
          The UI and saving button have been improved to allow settings to be changed without causing the confusion, ensuring a clearer and more intuitive experience.
          </p>
        </li>
        <li>New UI design of exported PDF feekback report
          <p>
          The new design improved readability, maintain consistency across pages, and provide a cleaner, more professional, and print-friendly report layout.
          </p>
        </li>
      </ul>

      {/* <ParaTitle paraTitle='Removed:' />
      <ul>
        <li>
          Duplicates in TSN feedback reports 
          <p>Fixed the counting issue in feedback reports.</p>
        </li>
      </ul> */}
      <Pagination
        pagination={{
          prev: { name: 'Updates: 3.45.0', link: '/updates/3.45.0' },
          next: { name: 'Updates: 3.43.0', link: '/updates/3.43.0' }
        }}
      />
    </div>

  )
}

export default Updates_3_44_0;